import { useFormController } from '@dreryk/react-common';
import { StyledFlex, TextView } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../../../../../translations';

import {
   DiagnosisAdditionalInformationFormBean,
   DiagnosisAdditionalInformationFormRenderer,
} from './DiagnosisAdditionalInformationForm.types';
import { DiagnosisAdditionalInformationTextarea } from './fields/DiagnosisAdditionalInformationTextarea';

type DiagnosisAdditionalInformationFormProps = {
   readonly additionalInformation: string | null;
   readonly children: DiagnosisAdditionalInformationFormRenderer;
   readonly code: string;
   readonly name: string;
};

export const DiagnosisAdditionalInformationForm = (props: DiagnosisAdditionalInformationFormProps): JSX.Element => {
   const { formState, handleSubmit, register } = useFormController<DiagnosisAdditionalInformationFormBean>({
      additionalInformation: props.additionalInformation,
   });

   return (
      <StyledFlex as={'form'} direction={'column'} gap={18} noValidate autoComplete={'off'}>
         <TextView
            testId={'diagnosisName'}
            label={visitDetailsTranslationKeys.diagnoses.diagnosisAdditionalInformation.form.diagnosis.label}
         >
            {`${props.code} ${props.name}`}
         </TextView>
         <DiagnosisAdditionalInformationTextarea register={register} />

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </StyledFlex>
   );
};
